import { AddressFeatureState } from '../../../../../../../@types/state-types'
import { ContentStateInterface, GeoCoordinates } from '../../../../../../../@types/types'
import initialState from '../../../../../../../redux/reducers/root/initialState'

export const geoCoordinatesToApi = (
  addressFeature: AddressFeatureState,
  insertionData: ContentStateInterface
): GeoCoordinates => {
  const { geoCoordinates, hasValidGeoCoordinates } = addressFeature
  const { geoCoordinates: initialGeoCoordinates } = initialState.addressFeature
  const manualGeoCoordinates = insertionData.manualQuarter?.geoCoordinates
    ? insertionData.manualQuarter.geoCoordinates
    : initialGeoCoordinates
  return hasValidGeoCoordinates ? geoCoordinates : manualGeoCoordinates
}
